"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dom = _interopRequireDefault(require("./dom"));

var _util = _interopRequireDefault(require("./util"));

var _detailsRenderer = _interopRequireDefault(require("./details-renderer"));

var _categoryRenderer = _interopRequireDefault(require("./category-renderer"));

var _performanceCategoryRenderer = _interopRequireDefault(require("./performance-category-renderer"));

var _pwaCategoryRenderer = _interopRequireDefault(require("./pwa-category-renderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview The entry point for rendering the Lighthouse report based on the JSON output.
 *    This file is injected into the report HTML along with the JSON report.
 *
 * Dummy text for ensuring report robustness: </script> pre$`post %%LIGHTHOUSE_JSON%%
 */

/** @typedef {import('./dom.js')} DOM */

/* globals self, Util, DetailsRenderer, CategoryRenderer, PerformanceCategoryRenderer, PwaCategoryRenderer */
var ReportRenderer =
/*#__PURE__*/
function () {
  /**
   * @param {DOM} dom
   */
  function ReportRenderer(dom) {
    _classCallCheck(this, ReportRenderer);

    /** @type {DOM} */
    this._dom = dom;
    /** @type {ParentNode} */

    this._templateContext = this._dom.document();
  }
  /**
   * @param {LH.Result} result
   * @param {Element} container Parent element to render the report into.
   * @return {Element}
   */


  _createClass(ReportRenderer, [{
    key: "renderReport",
    value: function renderReport(result, container) {
      // Mutate the UIStrings if necessary (while saving originals)
      var originalUIStrings = JSON.parse(JSON.stringify(_util["default"].UIStrings));

      this._dom.setLighthouseChannel(result.configSettings.channel || 'unknown');

      var report = _util["default"].prepareReportResult(result);

      container.textContent = ''; // Remove previous report.

      container.appendChild(this._renderReport(report)); // put the UIStrings back into original state

      _util["default"].updateAllUIStrings(originalUIStrings);

      return container;
    }
    /**
     * Define a custom element for <templates> to be extracted from. For example:
     *     this.setTemplateContext(new DOMParser().parseFromString(htmlStr, 'text/html'))
     * @param {ParentNode} context
     */

  }, {
    key: "setTemplateContext",
    value: function setTemplateContext(context) {
      this._templateContext = context;
    }
    /**
     * @param {LH.ReportResult} report
     * @return {DocumentFragment}
     */

  }, {
    key: "_renderReportTopbar",
    value: function _renderReportTopbar(report) {
      var el = this._dom.cloneTemplate('#tmpl-lh-topbar', this._templateContext);

      var metadataUrl =
      /** @type {HTMLAnchorElement} */
      this._dom.find('.lh-topbar__url', el);

      metadataUrl.href = metadataUrl.textContent = report.finalUrl;
      metadataUrl.title = report.finalUrl;
      return el;
    }
    /**
     * @return {DocumentFragment}
     */

  }, {
    key: "_renderReportHeader",
    value: function _renderReportHeader() {
      var el = this._dom.cloneTemplate('#tmpl-lh-heading', this._templateContext);

      var domFragment = this._dom.cloneTemplate('#tmpl-lh-scores-wrapper', this._templateContext);

      var placeholder = this._dom.find('.lh-scores-wrapper-placeholder', el);
      /** @type {HTMLDivElement} */


      placeholder.parentNode.replaceChild(domFragment, placeholder);
      return el;
    }
    /**
     * @param {LH.ReportResult} report
     * @return {DocumentFragment}
     */

  }, {
    key: "_renderReportFooter",
    value: function _renderReportFooter(report) {
      var _this = this;

      var footer = this._dom.cloneTemplate('#tmpl-lh-footer', this._templateContext);

      var env = this._dom.find('.lh-env__items', footer);

      env.id = 'runtime-settings';

      var envValues = _util["default"].getEnvironmentDisplayValues(report.configSettings || {});

      [{
        name: 'URL',
        description: report.finalUrl
      }, {
        name: 'Fetch time',
        description: _util["default"].formatDateTime(report.fetchTime)
      }].concat(_toConsumableArray(envValues), [{
        name: 'User agent (host)',
        description: report.userAgent
      }, {
        name: 'User agent (network)',
        description: report.environment && report.environment.networkUserAgent
      }, {
        name: 'CPU/Memory Power',
        description: report.environment && report.environment.benchmarkIndex.toFixed(0)
      }]).forEach(function (runtime) {
        if (!runtime.description) return;

        var item = _this._dom.cloneTemplate('#tmpl-lh-env__items', env);

        _this._dom.find('.lh-env__name', item).textContent = runtime.name;
        _this._dom.find('.lh-env__description', item).textContent = runtime.description;
        env.appendChild(item);
      });
      this._dom.find('.lh-footer__version', footer).textContent = report.lighthouseVersion;
      return footer;
    }
    /**
     * Returns a div with a list of top-level warnings, or an empty div if no warnings.
     * @param {LH.ReportResult} report
     * @return {Node}
     */

  }, {
    key: "_renderReportWarnings",
    value: function _renderReportWarnings(report) {
      if (!report.runWarnings || report.runWarnings.length === 0) {
        return this._dom.createElement('div');
      }

      var container = this._dom.cloneTemplate('#tmpl-lh-warnings--toplevel', this._templateContext);

      var message = this._dom.find('.lh-warnings__msg', container);

      message.textContent = _util["default"].UIStrings.toplevelWarningsMessage;

      var warnings = this._dom.find('ul', container);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = report.runWarnings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var warningString = _step.value;
          var warning = warnings.appendChild(this._dom.createElement('li'));
          warning.textContent = warningString;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return container;
    }
    /**
     * @param {LH.ReportResult} report
     * @param {CategoryRenderer} categoryRenderer
     * @param {Record<string, CategoryRenderer>} specificCategoryRenderers
     * @return {DocumentFragment[]}
     */

  }, {
    key: "_renderScoreGauges",
    value: function _renderScoreGauges(report, categoryRenderer, specificCategoryRenderers) {
      // Group gauges in this order: default, pwa, plugins.
      var defaultGauges = [];
      var customGauges = []; // PWA.

      var pluginGauges = [];

      for (var _i = 0, _Object$values = Object.values(report.categories); _i < _Object$values.length; _i++) {
        var category = _Object$values[_i];
        var renderer = specificCategoryRenderers[category.id] || categoryRenderer;
        var categoryGauge = renderer.renderScoreGauge(category, report.categoryGroups || {});

        if (_util["default"].isPluginCategory(category.id)) {
          pluginGauges.push(categoryGauge);
        } else if (renderer.renderScoreGauge === categoryRenderer.renderScoreGauge) {
          // The renderer for default categories is just the default CategoryRenderer.
          // If the functions are equal, then renderer is an instance of CategoryRenderer.
          // For example, the PWA category uses PwaCategoryRenderer, which overrides
          // CategoryRenderer.renderScoreGauge, so it would fail this check and be placed
          // in the customGauges bucket.
          defaultGauges.push(categoryGauge);
        } else {
          customGauges.push(categoryGauge);
        }
      }

      return [].concat(defaultGauges, customGauges, pluginGauges);
    }
    /**
     * @param {LH.ReportResult} report
     * @return {DocumentFragment}
     */

  }, {
    key: "_renderReport",
    value: function _renderReport(report) {
      var _this2 = this;

      var detailsRenderer = new _detailsRenderer["default"](this._dom);
      var categoryRenderer = new _categoryRenderer["default"](this._dom, detailsRenderer);
      categoryRenderer.setTemplateContext(this._templateContext);
      /** @type {Record<string, CategoryRenderer>} */

      var specificCategoryRenderers = {
        performance: new _performanceCategoryRenderer["default"](this._dom, detailsRenderer),
        pwa: new _pwaCategoryRenderer["default"](this._dom, detailsRenderer)
      };
      Object.values(specificCategoryRenderers).forEach(function (renderer) {
        renderer.setTemplateContext(_this2._templateContext);
      });

      var headerContainer = this._dom.createElement('div');

      headerContainer.appendChild(this._renderReportHeader());

      var reportContainer = this._dom.createElement('div', 'lh-container');

      var reportSection = this._dom.createElement('div', 'lh-report');

      reportSection.appendChild(this._renderReportWarnings(report));
      var scoreHeader;
      var isSoloCategory = Object.keys(report.categories).length === 1;

      if (!isSoloCategory) {
        scoreHeader = this._dom.createElement('div', 'lh-scores-header');
      } else {
        headerContainer.classList.add('lh-header--solo-category');
      }

      if (scoreHeader) {
        var _scoreHeader;

        var scoreScale = this._dom.cloneTemplate('#tmpl-lh-scorescale', this._templateContext);

        var scoresContainer = this._dom.find('.lh-scores-container', headerContainer);

        (_scoreHeader = scoreHeader).append.apply(_scoreHeader, _toConsumableArray(this._renderScoreGauges(report, categoryRenderer, specificCategoryRenderers)));

        scoresContainer.appendChild(scoreHeader);
        scoresContainer.appendChild(scoreScale);

        var stickyHeader = this._dom.createElement('div', 'lh-sticky-header');

        stickyHeader.append.apply(stickyHeader, _toConsumableArray(this._renderScoreGauges(report, categoryRenderer, specificCategoryRenderers)));
        reportContainer.appendChild(stickyHeader);
      }

      var categories = reportSection.appendChild(this._dom.createElement('div', 'lh-categories'));

      for (var _i2 = 0, _Object$values2 = Object.values(report.categories); _i2 < _Object$values2.length; _i2++) {
        var category = _Object$values2[_i2];
        var renderer = specificCategoryRenderers[category.id] || categoryRenderer; // .lh-category-wrapper is full-width and provides horizontal rules between categories.
        // .lh-category within has the max-width: var(--report-width);

        var wrapper = renderer.dom.createChildOf(categories, 'div', 'lh-category-wrapper');
        wrapper.appendChild(renderer.render(category, report.categoryGroups));
      }

      var reportFragment = this._dom.createFragment();

      var topbarDocumentFragment = this._renderReportTopbar(report);

      reportFragment.appendChild(topbarDocumentFragment);
      reportFragment.appendChild(reportContainer);
      reportContainer.appendChild(headerContainer);
      reportContainer.appendChild(reportSection);
      reportSection.appendChild(this._renderReportFooter(report));
      return reportFragment;
    }
  }]);

  return ReportRenderer;
}(); // /** @type {LH.I18NRendererStrings} */
// ReportRenderer._UIStringsStash = {};
// if (typeof module !== 'undefined' && module.exports) {
//   module.exports = ReportRenderer;
// } else {
//   self.ReportRenderer = ReportRenderer;
// }


var _default = ReportRenderer;
exports["default"] = _default;